// Create-channel Drawer. Field values stay component-local and secret values
// are cleared with the unmounted form after a successful write.

import type { components } from "../../api/schema";
import { Drawer } from "../../ui";
import { AlertChannelForm } from "./AlertChannelForm";

type AlertChannelCreate = components["schemas"]["AlertChannelCreate"];
type AlertChannelType = components["schemas"]["AlertChannelType"];

export interface NewAlertChannelDrawerProps {
  availableChannelTypes: AlertChannelType[];
  isPending: boolean;
  onDismiss: () => void;
  onSubmit: (body: AlertChannelCreate) => void;
}

export function NewAlertChannelDrawer({
  availableChannelTypes,
  isPending,
  onDismiss,
  onSubmit,
}: NewAlertChannelDrawerProps) {
  return (
    <Drawer ariaLabel="Create channel" isOpen onDismiss={onDismiss}>
      <AlertChannelForm
        availableChannelTypes={availableChannelTypes}
        isPending={isPending}
        onCancel={onDismiss}
        onSubmit={onSubmit}
        submitLabel="Create channel"
      />
    </Drawer>
  );
}
